var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.414,
    height: 18.217,
    viewBox: "0 0 19.414 18.217",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group",
    transform: "translate(.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__house-chimney-2",
    transform: "translate(.5 .5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape",
    d: "M0 0v7.043a.783.783 0 0 0 .783.783H4.3a.391.391 0 0 0 .4-.391V4.3a1.957 1.957 0 1 1 3.913 0v3.13A.391.391 0 0 0 9 7.826h3.522a.783.783 0 0 0 .783-.783V.391",
    className: "prefix__cls-1",
    transform: "translate(2.348 9.391)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape-2",
    d: "M0 9l9-9 9 9",
    className: "prefix__cls-1",
    "data-name": "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape-3",
    d: "M0 0h2.348a.391.391 0 0 1 .391.391v2.348",
    className: "prefix__cls-1",
    "data-name": "Shape",
    transform: "translate(12.13 .783)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSidebar);
export default __webpack_public_path__ + "static/media/home-sidebar.1d0b6b24048ef198c0f81330a21459f5.svg";
export { ForwardRef as ReactComponent };